export default "__VITE_PUBLIC_ASSET__281891de__"